// Interceptor global de `fetch` y `axios` para auditoría.
// Inyecta el header X-Pantalla con el nombre funcional de la pantalla actual
// en cada request hacia el backend. Se importa al inicio de `index.jsx`
// antes que cualquier otro módulo que pueda emitir requests.

import axios from 'axios';
import { ROUTE_LABEL_MAP } from '../utils/auditoriaLabels';

const isApiUrl = (url) => {
  try {
    if (!url) return false;
    const s = typeof url === 'string' ? url : url.url || '';
    return s.includes('/api/');
  } catch (_e) {
    return false;
  }
};

/**
 * Devuelve el nombre funcional de la pantalla activa.
 * Prioridad: ROUTE_LABEL_MAP[pathname] → pathname (fallback, evita envío vacío).
 */
const currentPantalla = () => {
  try {
    if (typeof window === 'undefined' || !window.location) return '';
    const pathname = window.location.pathname || '';
    if (!pathname) return '';
    // Intentar match exacto
    if (ROUTE_LABEL_MAP[pathname]) return ROUTE_LABEL_MAP[pathname];
    // Intentar sin query-params / hash (rutas con parámetros opcionales)
    const base = pathname.split('?')[0].split('#')[0];
    return ROUTE_LABEL_MAP[base] || pathname;
  } catch (_e) {
    return '';
  }
};

(function installFetchAuditInterceptor() {
  if (typeof window === 'undefined' || typeof window.fetch !== 'function') return;
  if (window.__luxFetchInterceptorInstalled) return;
  window.__luxFetchInterceptorInstalled = true;

  const originalFetch = window.fetch.bind(window);

  window.fetch = function patchedFetch(input, init) {
    try {
      const url = typeof input === 'string' ? input : (input && input.url) || '';
      if (!isApiUrl(url)) return originalFetch(input, init);

      const newInit = { ...(init || {}) };
      const existingHeaders = newInit.headers || (input && input.headers) || {};
      const merged = new Headers(existingHeaders);
      if (!merged.has('X-Pantalla')) {
        merged.set('X-Pantalla', currentPantalla());
      }
      newInit.headers = merged;
      return originalFetch(input, newInit);
    } catch (_e) {
      return originalFetch(input, init);
    }
  };
})();

(function installAxiosAuditInterceptor() {
  try {
    if (!axios || !axios.interceptors || !axios.interceptors.request) return;
    if (axios.__luxAuditInterceptorInstalled) return;
    axios.__luxAuditInterceptorInstalled = true;

    axios.interceptors.request.use((config) => {
      try {
        const url = (config && (config.url || '')) + '';
        const baseUrl = (config && (config.baseURL || '')) + '';
        const fullUrl = url.startsWith('http') ? url : baseUrl + url;
        if (!isApiUrl(fullUrl)) return config;
        config.headers = config.headers || {};
        if (!config.headers['X-Pantalla'] && !config.headers['x-pantalla']) {
          config.headers['X-Pantalla'] = currentPantalla();
        }
      } catch (_e) {
        // no-op
      }
      return config;
    });
  } catch (_e) {
    // no-op
  }
})();
